import { forwardRef, useContext } from "react";

import Box from "@/components/Box";
import { InternalTextLink } from "@/components/Links";
import Text from "@/components/Text";
import { ResultPresentationConsumer } from "@/contexts/ResultPresentation";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { CMP_PATIENTS_USER_DATAPOINT_URL, getCmpUrl } from "@/core/urls";
import { GenesAllelesText } from "@/tpo/ChartCards";
import Group from "@/tpo/Group";
import { ViewerContext } from "@/tpo/Viewer";

import DatapointCharts from "./DatapointCharts";

const GeneDatapointSummary = forwardRef(({ bg, userDatapoint, openModal, gap, py, px }, ref) => {
  const viewerContext = useContext(ViewerContext);
  const clientId = viewerContext?.userId;

  const nameParts = userDatapoint.datapoint.name.split("-").map(part => part.trim());
  const rsId = nameParts[1] ? `rs${nameParts[1].replace(/^rs/i, "")}` : null;

  const organisationContext = useOrganisationContext();
  const organisationId = organisationContext?.organisation?.hashId;

  let href;

  href = getCmpUrl(CMP_PATIENTS_USER_DATAPOINT_URL, {
    patientId: clientId,
    organisationId,
    userDatapointId: userDatapoint.id
  });

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={gap}
      py={py}
      key={userDatapoint.id}
      bg={bg}
      px={px}
      ref={ref}
    >
      <Box width="40%">
        {openModal ? (
          <Text
            fontSize={[14, 14, 15]}
            color="anchorBlue"
            cursor="pointer"
            onClick={() => openModal(userDatapoint)}
            marginCorrection={false}
          >
            {nameParts[0]}
          </Text>
        ) : (
          <InternalTextLink fontSize={[14, 14, 15]} href={href}>
            {nameParts[0]}
          </InternalTextLink>
        )}
      </Box>
      <Box width="40%">
        {rsId &&
          (openModal ? (
            <Text
              fontSize={[14, 14, 15]}
              color="anchorBlue"
              cursor="pointer"
              onClick={() => openModal(userDatapoint)}
              marginCorrection={false}
            >
              {rsId}
            </Text>
          ) : (
            <InternalTextLink fontSize={[14, 14, 15]} href={href}>
              {rsId}
            </InternalTextLink>
          ))}
      </Box>
      <Group justifyContent="flex-end" width="40%">
        <DatapointCharts datapoint={userDatapoint}>
          <ResultPresentationConsumer>
            {({ chartProps, interpretationColor }) => {
              if (userDatapoint.datapoint.chartType === "GENES_ALLELES_CHART") {
                return (
                  <GenesAllelesText
                    text={chartProps.type}
                    color={chartProps.badgeColor}
                    fontSize={12}
                    fontFamily="gilroyBold"
                  />
                );
              }
              // I don't think this. should ever be hit
              return (
                <Text
                  fontSize={[14, 14, 15]}
                  fontFamily="gilroyBold"
                  color={interpretationColor}
                  textAlign="right"
                >
                  {userDatapoint?.chartConfiguration?.interpretation}
                </Text>
              );
            }}
          </ResultPresentationConsumer>
        </DatapointCharts>
      </Group>
    </Box>
  );
});

export default GeneDatapointSummary;
